<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Question Section</h1>
          <p class="mt-2 text-sm text-gray-700">Details</p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button @click="cancel" type="button" class="pull-right block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Back</button>
        </div>
      </div>
      <div class="mt-6 border-t border-gray-100">
        <dl class="divide-y divide-gray-100">
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">ID</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ questionSection.id }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Title</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ questionSection.title }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Regulatory Key</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ questionSection.key }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Subtitle</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ questionSection.subtitle }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Text</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 trix-editor"><span v-html="questionSection.text"></span></dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Dashboard content</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 trix-editor"><span v-html="questionSection.dashboard_content"></span></dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Regulatory permissions</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 trix-editor">{{ questionSection.regulatory_permission_labels }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Firm type</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 trix-editor">{{ questionSection.firm_type_labels }}</dd>
          </div>
        </dl>
      </div>
    </div>
  </div>

  <div class="overflow-hidden rounded-lg bg-white shadow mt-4">
    <div class="px-4 py-5 sm:p-6">
      <QuestionSectionScoreContentIndexComponent />
    </div>
  </div>
</template>

<script>
import QuestionSectionScoreContentIndexComponent from "./ScoreContent/QuestionSectionScoreContentIndexComponent.vue";

export default {
  name: "QuestionSectionShowComponent",
  data() {
    return {
      questionSection: {
        id: null,
        title: null,
        website: null,
        key: null,
      }
    }
  },
  components: {
    QuestionSectionScoreContentIndexComponent,
  },
  computed: {
    questionSectionId() {
      return this.$route.params.id ? parseInt((this.$route.params.id)) : null;
    },
  },
  methods: {
    getQuestionSection() {
      axios.get(`/member-firm/question-section/show/${this.questionSectionId}`).then((res) => {
        this.questionSection = res.data.data;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    cancel() {
      this.$router.back();
    },
  },
  mounted() {
    if (this.questionSectionId) {
      this.getQuestionSection();
    }
  }

}
</script>